import { BrandConfiguration } from '../interfaces';
import { useActiveBrandConfig } from './useActiveBrandConfig';

export const useBrandFeatureCheck = (
  featureKey: keyof BrandConfiguration['features']
) => {
  const { features } = useActiveBrandConfig();
  return Boolean(features[featureKey]);
};
